// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8262b5c6f0df9632c11fb514e823bed906a3fa7c.chunk.js";
};